import { render } from "./App.vue?vue&type=template&id=7ac6888a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7ac6888a&lang=scss"

import exportComponent from "F:\\myCode\\NCCT（通讯终端）\\txzd\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__